export const paceTooltipText = "Placeholder zeros can be omitted. For instance, 4 minutes 9 seconds can be entered as 4:09 instead of 00:04:09.";
